const DEFAULT_LANG = "en-US"
const DEFAULT_RATE = 0.5

class SpeechSynthesizer {


    constructor() {

    }

    // static setSpeech() {
    //     return new Promise((resolve, reject) => {
    //         let synth = window.speechSynthesis;
    //         let id;

    //         id = setInterval(() => {
    //             if (synth.getVoices().length !== 0) {
    //                 resolve(synth.getVoices());
    //                 clearInterval(id);
    //             } else {
    //                 reject(new Error('No voice has found.'))
    //             }
    //         }, 10);
    //     }
    //     )
    // }

    static speak(args) {
        let self = this
        if (args.sr) {
            this.sr = args.sr
        }
        const ss = new SpeechSynthesisUtterance(args.text);

        ss.addEventListener('start', (event) => {
            const ev = new CustomEvent('speech-synthesis-boundary', {
                detail: event
            })
            document.dispatchEvent(ev)
        })
        ss.addEventListener('end', (event) => {
            const ev = new CustomEvent('speech-synthesis-boundary', {
                detail: event
            })
            document.dispatchEvent(ev)
        })

        ss.addEventListener('boundary', (event) => {
            const ev = new CustomEvent('speech-synthesis-boundary', {
                detail: event
            })
            document.dispatchEvent(ev)
        })

        ss.rate = args.rate || DEFAULT_RATE;
        ss.lang = args.lang || DEFAULT_LANG;

        if (args.sr) {
            self.sr.stopRecog();
            ss.addEventListener("end", () => {
                self.sr.startRecog();
            })
        }
        window.speechSynthesis.speak(ss);

    }
}

export default SpeechSynthesizer;